<!-- 公共窗框页 -->
<template>
  <div class="enter_page">
    <router-view
      :wannaSubmit="wannaSubmit"
      :options="totalOption"
      @listenSelectProChange="selectProChanged"
      @listenEmitTotalOption="initTotalOption"
      @listenSubmitCheckFinish="submitCheckFinish"
      @listenChangeSubmiting="changeSubmiting"
      @listenDealFormDataFinish="dealFormDataFinish"
      @listenLoadConfig="loadConfigFinish"
    />
    <!-- 价格明细 -->
    <PriceDetail
      :show="showPriceDetail"
      :list="selectProList"
      :payable="payable"
      :title="$t('footerbtn.detailtitle')"
      :currency="currency"
      @listenHandleClosePriceDetail="handleClosePriceDetail"
    ></PriceDetail>

    <!-- 优惠码使用 -->
    <div
      class="coupon_use_wrap"
      :class="showCoupon ? 'coupon_use_wrap_show' : ''"
    >
      <CouponInput></CouponInput>
    </div>

    <!-- 底部内容 -->
    <SubmitComponent
      :isDetail="showPriceDetail"
      :payable="payable"
      :oldPayable="oldPayable"
      :isUseCoupons="isUseCoupons"
      :canSubmit="canSubmit"
      :submiting="submiting"
      :hasProduct="hasProduct"
      :currency="currency"
      @listenHandleShowPriceDetail="handleShowPriceDetail"
      @listenUseCoupon="handleUseCoupon"
      @listenWannasubmitForm="wannaSubmitForm"
    ></SubmitComponent>

    <!-- 未支付订单 -->
    <CusPayAgain
      :show="showUnpaidOrder"
      :orderno="waitOrder"
      :payment="payment_way"
      :payment_method="payment_method"
      @listenCloseDialog="closeDialog"
      @listenAlipayInWechat="alipayInWechat"
    />

    <!-- 支付方式选择 -->
    <PaymentWay
      :payment="payment"
      :show="showPayment"
      :offlinetext="offline_pay_text"
      :isuploadcert="is_offline_pay_cert"
      @listenClosePickPaymentMethod="closePaymentPicker"
      @listenPickedPaymentWay="pickedPaymentWay"
    />

    <!-- 加载中 -->
    <CusLoading :show="loading" />
    
    <!-- 支付宝弹框显示复制订单地址到其他浏览器支付 -->
    <component :is="isShowJumpPay ? 'JumpPay' : ''" :isShow="isShowJumpPay" :url="jumpPayUrl" :orderNo="params.orderNo" :accountUid="params.accountid" :projectUid="params.projectid" />
  </div>
</template>

<script>
import SubmitComponent from '@c/submitComponent'
import CouponInput from '@c/couponInput'
import PriceDetail from '@c/priceDetail'
import PaymentWay from '@c/paymentWay'
import CusPayAgain from '@c/CusPayAgain'
import CusLoading from '@c/CusLoading'
import apiObj from '@a/js/api.js'

import wx from 'weixin-js-sdk'
import { CreateOrder, GetOrderIsPaid } from '@a/js/api/pay.js'
import { GetVersionOption } from '@a/js/api/public'
import JumpPay from '@c/JumpPay.vue'

export default {
  name: 'Enter',
  data() {
    return {
      // 价格明细相关
      showPriceDetail: false,
      selectProList: [],
      formData: {},
      //  --应付
      payable: 0,
      //  --优惠前
      oldPayable: 0,
      isUseCoupons: false,
      canSubmit: false,
      // 是否存在选中的商品
      hasProduct: false,
      // 是否展示优惠码输入框
      showCoupon: false,
      showPayment: false,
      showUnpaidOrder: false,
      // 币种
      currency: '￥',
      wannaSubmit: false,
      submiting: false,
      // 整体设置配置
      totalOption: {},
      payment: [],
      payment_way: '',
      payment_method: '',
      waitOrder: '',
      params: {},
      loading: false,
      offline_pay_text: '',
      is_offline_pay_cert: 0,
      isShowJumpPay: false, // 微信内支付宝支付，显示复制链接
      jumpPayUrl: "" // 复制到浏览器打开的支付宝订单页面地址
    }
  },

  components: {
    SubmitComponent,
    CouponInput,
    PriceDetail,
    PaymentWay,
    CusPayAgain,
    CusLoading,
    JumpPay
  },

  watch: {
    selectProList: {
      handler(data) {
        let price = 0
        data.map((item) => {
          if (item.quantity !== 0) {
            price += item.price * item.quantity
          }
        })
        this.payable = this.oldPayable = price

        if (data.length !== 0) {
          this.canSubmit = true
          this.hasProduct = true
        } else {
          this.canSubmit = false
          this.hasProduct = false
        }
      },
      deep: true,
      immediate: true,
    },
  },

  computed: {
    is_jump() {
      return this.totalOption.is_submit_jump_url ? 1 : 0
    },
    jump_url() {
      return this.totalOption.submit_jump_url ? this.totalOption.submit_jump_url : ''
    },
    program_env() {
      return window.location.host === 'c.banhuiyun.com' ? 'pro' : 'dev'
    }
  },

  methods: {
    // 查看价格明细
    handleShowPriceDetail(type) {
      if (type === undefined) {
        this.showPriceDetail = !this.showPriceDetail
      } else {
        this.showPriceDetail = type
      }
    },
    // 关闭详情
    handleClosePriceDetail() {
      this.showPriceDetail = false
    },
    // 选择的商品发生变化
    selectProChanged(list) {
      this.selectProList = list
    },
    // 货币类型发生变化
    initTotalOption(config) {
      this.currency = config.currency ? config.currency : '￥'
      this.payment = config.payment
      this.totalOption = config
    },
    // 表单内容校验不通过
    submitCheckFinish() {
      this.wannaSubmit = false
    },
    // 返回页面顶部
    scrollTo() {
      window.scrollTo(0, 0)
    },
    // 想要使用优惠码
    handleUseCoupon(type) {
      if (type === undefined) {
        this.showCoupon = !this.showCoupon
      } else {
        this.showCoupon = type
      }
    },
    // 关闭支付方式选择
    closePaymentPicker() {
      this.showPayment = false
    },
    // 打开支付方式选择
    wannaPickPayment() {
      this.showPayment = true
    },
    // 切换提交状态
    changeSubmiting(type) {
      this.submiting = type
    },
    // 数据校验完成
    dealFormDataFinish(data) {
      this.formData = data
      this.wannaPickPayment()
    },
    // 表单页面点击确定按钮
    wannaSubmitForm() {
      this.wannaSubmit = true
    },
    // 确认选择支付方式
    pickedPaymentWay(val, cert) {
      this.submiting = true
      this.showPayment = false
      this.wannaSubmitOrder(val, cert)
    },
    // 数据提交
    wannaSubmitOrder(way, cert) {
      this.loading = true
      this.dealDataBeforeSubmit(way, cert).then(data => {
        console.log(data)
        CreateOrder(data, this.$root.language).then(async res => {

          if (res.code == '10001') {
            this.loading = false
            this.submiting = false
            this.waitOrder = res.data.order_no
            this.payment_way = res.data.payment
            this.payment_method = res.data.payment_method
            this.showUnpaidOrder = true

          } else {
            let info = {
              accountid: this.params.accountid,
              projectid: this.params.projectid,
              orderid: res.data.order_no
            }
            this.$storeLocal.set('ticket_order', info)

            if (data.payment.indexOf('offline') != -1) {

              // 线下转账
              if (this.totalOption.is_submit_jump_url) {
                window.location.href = this.totalOption.submit_jump_url
              } else {
                this.$router.push({
                  name: 'Result',
                  params: {
                    accountid: this.params.accountid,
                    projectid: this.params.projectid,
                    orderid: res.data.order_no,
                    language: this.$i18n.locale
                  }
                })
              }
            } else if (data.payment.indexOf('wxpay') != -1) {

              // 微信支付
              this.judgeIsMiniProgran().then(() => {

                // 小程序
                let return_url = ''
                if (this.totalOption.is_submit_jump_url) {
                  return_url = this.totalOption.submit_jump_url
                } else {
                  return_url = apiObj.VUE_APP_BASE_SERVE + 'ticket/result/' + this.params.accountid + '/' + this.params.projectid + '/' + res.data.order_no + '/' + this.$i18n.locale
                }

                wx.miniProgram.navigateTo({
                  url: '/pages/payment/index?req_type=BUnion&account_uid=' + this.params.accountid + '&project_uid=' + this.params.projectid + '&order_no=' + res.data.order_no + '&env=' + this.program_env + '&return_url=' + return_url,
                  success: () => { },
                  fail: () => { }
                })

              }).catch(() => {

                // 浏览器
                let apiurl = apiObj.VUE_APP_BASE_API + '/g/v1/pay_bhy/pay?req_type=BUnion&account_uid=' + this.params.accountid + '&project_uid=' + this.params.projectid + '&order_no=' + res.data.order_no + '&return_url='

                let return_url = ''
                if (this.totalOption.is_submit_jump_url) {
                  return_url = this.totalOption.submit_jump_url
                } else {
                  return_url = apiObj.VUE_APP_BASE_SERVE + 'ticket/result/' + this.params.accountid + '/' + this.params.projectid + '/' + res.data.order_no + '/' + this.$i18n.locale
                }

                let paid_url = apiurl + return_url

                window.location.href = paid_url
                // console.log(paid_url)
                // console.log(return_url)
              })
            } else {

              // 支付宝 & paypal
              // 拼接 apiurl
              const apiurl = apiObj.VUE_APP_BASE_API + '/g/v1/pay_bhy/pay?req_type=BUnion&account_uid=' + this.params.accountid + '&project_uid=' + this.params.projectid + '&order_no=' + res.data.order_no + '&return_url='

              // 拼接 return_url
              let return_url = ''

              if (this.totalOption.is_submit_jump_url) {

                // 有设置购票后跳转链接
                return_url = this.totalOption.submit_jump_url
              } else {

                // 未设置购票后跳转链接
                return_url = apiObj.VUE_APP_BASE_SERVE + 'ticket/result/' + this.params.accountid + '/' + this.params.projectid + '/' + res.data.order_no + '/' + this.$i18n.locale
              }

              // 支付宝支付 & 微信内 & ios 系统
              if (data.payment.indexOf('alipay') != -1 &&
                this.judgeIsWeiXin() &&
                await this.JudgeTerminalType() === 'ios'
              ) {

                console.log('weichat & ios')
                console.log(return_url)
                console.log(res.data.order_no)
                this.params.orderNo = res.data.order_no
                this.jumpPayUrl = apiurl + return_url

                this.loading = false

                // 显示复制链接到浏览器支付
                this.isShowJumpPay = true
              }
              else {
                // 支付宝（非微信内 & 非 ios） or paypal 跳转支付
                window.location.href = apiurl + return_url
              }
            }
          }
        }).catch(() => {
          this.loading = false
          this.submiting = false
        })
      })
    },
    // 判断是否微信浏览器
    judgeIsWeiXin() {
      var ua = window.navigator.userAgent.toLowerCase();
      // console.log(ua);//mozilla/5.0 (iphone; cpu iphone os 9_1 like mac os x) applewebkit/601.1.46 (khtml, like gecko)version/9.0 mobile/13b143 safari/601.1
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        return true;
      } else {
        return false;
      }
    },
    // 判断是否小程序内打开
    judgeIsMiniProgran() {
      return new Promise((resolve, reject) => {
        wx.miniProgram.getEnv(res => {
          // alert(JSON.stringify(res))
          if (res.miniprogram) {
            resolve()
          }
          reject()
        })
        reject()
      })
    },

    // 订单提交前处理数据
    dealDataBeforeSubmit(way, cert) {
      return new Promise((resolve) => {
        let data = {
          req_type: 'BTicket',
          account_uid: this.params.accountid,
          project_uid: this.params.projectid,
          app_name: this.$AppName,
          payment: way,
          offline_pay_cert: cert,
          form_data: this.formData,
          time_begin: '',
          time_end: ''
        }
        let good_list = []
        this.selectProList.map((item) => {
          let innerItem = {}
          if (item.quantity > 0) {
            innerItem.uid = item.uid
            innerItem.goods_name = item.goods_name
            innerItem.quantity = item.quantity
            good_list.push(innerItem)
          }
        })
        data.goods = good_list
        if (data.payment.indexOf('wxpay') !== -1) {
          this.judgeIsMiniProgran().then(() => {
            data.payment = 'wxpay_miniprogram'
          })
        }
        resolve(data)
      })
    },

    // 关闭未支付弹窗
    closeDialog() {
      this.showUnpaidOrder = false
    },
    // 获取参数信息
    GetParamsData() {
      return new Promise(resolve => {
        this.params = this.$route.params;
        this.$root.language = this.params.language ? this.params.language : 'zh'
        this.$i18n.locale = this.$root.language
        resolve();
      });
    },
    // 初始化版权信息
    initVersionOption() {
      let data = {
        account_uid: this.params.accountid,
        app_name: 'version',
        type: 4
      }
      GetVersionOption(data).then(res => {
        this.$root.isVersion = res.data.is_version
      }).catch(() => { })
    },
    // 判断终端类型
    JudgeTerminalType() {
      return new Promise((resolve, reject) => {

        const uAgent = navigator.userAgent

        if (/(iPhone|iPad|iPod|iOS)/i.test(uAgent)) {
          resolve("ios")
        }
        else if (/(Android)/i.test(uAgent)) {
          resolve("android")
        }
        else {
          resolve("other")
        }
      })
    },
    // 查看本地是否存有订单信息
    judgeIsSaveOrder() {
      let local = this.$storeLocal.get('ticket_order')

      if (local && local.accountid == this.params.accountid && local.projectid == this.params.projectid && local.orderid) {

        // 查询订单信息
        let data = {
          req_type: 'BTicket',
          account_uid: this.params.accountid,
          project_uid: this.params.projectid,
          order_no: local.orderid
        }

        GetOrderIsPaid(data, this.$root.language).then(res => {
          if (res.code == 1 && res.data.payment && res.data.order_no) {
            this.waitOrder = res.data.order_no
            this.payment_way = res.data.payment
            this.payment_method = res.data.payment_method
            this.showUnpaidOrder = true
          }
        }).catch(() => { })
      }
    },
    // 设置转账付款配置
    loadConfigFinish(config) {
      this.is_offline_pay_cert = config.is_offline_pay_cert ? 1 : 0
      this.offline_pay_text = config.offline_pay_text ? config.offline_pay_text : ''
    },
    alipayInWechat(orderNo, jumpPayUrl){
      console.log('orderNo: ', orderNo)
      console.log('jumpPayUrl: ', jumpPayUrl)

      this.jumpPayUrl = jumpPayUrl
      this.params.orderNo = orderNo
      this.loading = false
      this.isShowJumpPay = true
    }
  },
  mounted() {
    window.addEventListener('beforeunload', this.scrollTo)
    this.GetParamsData().then(() => {
      this.initVersionOption()
      this.judgeIsSaveOrder()
      // this.JudgeTerminalType().then(() => {
      //   this.initVersionOption()
      // }).catch(() => {
      //   console.log('guide')
      //   this.$router.push({
      //     name: 'Guide',
      //     params: {
      //       accountid: this.params.accountid,
      //       projectid: this.params.projectid
      //     }
      //   })
      // })
    })
  },
}
</script>
<style lang="less" scoped>
.coupon_use_wrap {
  position: fixed;
  bottom: 0px;
  left: 0;
  right: 0;
  z-index: 80;
  transition: all 0.3s;
}

.coupon_use_wrap_show {
  bottom: 90px;
}
</style>
